<template>
  <div class="user-product-category">
    <x-table
      :no-data-text="
        CA('userProduct_add') ? '暂无数据' : '暂无数据查询权限'
      "
      :columns="table.columns"
      :data="table.data"
      :loading="table.loading"
      :config="config"
      @add="add"
      @search="search"
      @page-change="pageChange"
      @page-size-change="pageSizeChange"
    ></x-table>

    <Modal
      v-model="modal.show"
      :title="modal.title"
      @on-visible-change="modalShow"
    >
      <Form ref="form" :model="form" :rules="rules" :label-width="100">
        <FormItem label="分类名称" prop="name">
          <Input v-model="form.name"></Input>
        </FormItem>
        <FormItem label="备注" prop="remark">
          <Input v-model="form.remark" type="textarea" :rows="3"></Input>
        </FormItem>
      </Form>
      <p slot="footer" style="text-align: center">
        <Button type="primary" :loading="modal.submitLoading" @click="submit"
          >提交</Button
        >
        <Button @click="() => (modal.show = false)">取消</Button>
      </p>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      table: {
        columns: [
          {
            title: "分类名称",
            minWidth: 100,
            key: "name",
          },
          {
            title: "备注",
            minWidth: 100,
            key: "remark",
          },
          {
            title: "操作",
            width: 150,
            render: (h, { row }) => {
              return (
                <div>
                  {this.CA("userProduct_add") && (
                    <a
                      style="margin-right: 10px"
                      onClick={() => this.edit(row)}
                    >
                      编辑
                    </a>
                  )}
                  {this.CA("userProduct_add") && (
                    <Poptip
                      confirm
                      transfer
                      title="确定删除吗?"
                      on-on-ok={() => this.del(row.id)}
                    >
                      <a>删除</a>
                    </Poptip>
                  )}
                </div>
              );
            },
          },
        ],
        data: [],
        loading: false,
      },
      page: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      search_data: [],
      modal: {
        show: false,
        title: "",
        submitLoading: false,
      },
      form: {
        id: "",
        name: "",
        remark: "",
      },
      rules: {
        name: [{ required: true, message: "请填写分类名称" }],
      },
    };
  },
  computed: {
    config() {
      let config = {
        filter: {
          add: {
            addBtnName: "新增产品分类",
            ca: "userProduct_add",
          },
          width: 200,
          filterBox: [
            {
              conditionName: "分类名称",
              component: "input",
              field: "name",
              defaultValue: "",
            },
          ],
        },
        page: this.page,
      };
      return config;
    },
  },
  methods: {
    add() {
      this.modal = {
        show: true,
        title: "新增产品分类",
        submitLoading: false,
      };
    },
    search(data) {
      this.page.pageNo = 1;
      this.search_data = data;
      this.getList();
    },
    pageChange(pageNo) {
      this.page.pageNo = pageNo;
      this.getList();
    },
    pageSizeChange(pageSize) {
      this.page.pageSize = pageSize
      this.getList()
    },
    getList() {
      if (!this.CA("userProduct_add")) return;
      this.table.loading = true;
      this.$post(this.$api.USER_PRODUCT_CATEGORY.LIST, {
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
        ...this.search_data,
      })
        .then((res) => {
          this.table.data = res.list;
          this.page.total = +res.total;
        })
        .finally(() => {
          this.table.loading = false;
        });
    },
    edit(row) {
      for (let key in this.form) {
        this.form[key] = row[key];
      }
      this.modal = {
        show: true,
        title: "编辑产品分类",
        submitLoading: false,
      };
    },
    del(id) {
      this.$post(this.$api.USER_PRODUCT_CATEGORY.DELETE, {
        id,
      }).then(() => {
        this.$Message.success("删除成功");
        this.getList();
        this.$emit('change')
      });
    },
    modalShow(visible) {
      if (visible) return;
      this.form = {
        id: "",
        name: "",
        remark: "",
      };
      this.$refs.form.resetFields();
    },
    submit() {
      this.$refs.form.validate().then((res) => {
        if (!res) return;
        this.modal.submitLoading = true;
        this.$post(
          this.form.id
            ? this.$api.USER_PRODUCT_CATEGORY.EDIT
            : this.$api.USER_PRODUCT_CATEGORY.ADD,
          {
            ...this.form,
          }
        )
          .then(() => {
            this.$emit('change')
            this.getList();
            this.modal.show = false;
          })
          .finally(() => {
            this.modal.submitLoading = false;
          });
      });
    },
  },
  mounted() {
    this.getList();
  },
};
</script>

<style lang="less" scoped>
.user-product-category {
  width: 100%;
  height: 100%;
}
</style>
